export default __webpack_public_path__ + "static/media/0035.5e05ab50.png";